// HARDER cart drawer: opens from any cart link, updates quantities through the
// Cart AJAX API, and re-renders itself with the Section Rendering API.
(function(){
  var SECTION='hdr-cart-drawer';
  function drawer(){return document.querySelector('[data-cart-drawer]');}
  function open(){var d=drawer();if(!d)return;d.classList.add('open');d.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    var x=d.querySelector('[data-cd-close]');if(x&&x.focus)x.focus();}
  function close(){var d=drawer();if(!d)return;d.classList.remove('open');d.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';}

  function refresh(){
    return fetch(window.location.pathname+'?sections='+SECTION,{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(j){
        var html=j[SECTION]; if(!html)return;
        var wrap=document.createElement('div'); wrap.innerHTML=html;
        var fresh=wrap.querySelector('[data-cart-drawer]'), cur=drawer();
        if(fresh&&cur){var wasOpen=cur.classList.contains('open');
          cur.parentNode.replaceChild(fresh,cur);
          if(wasOpen){fresh.classList.add('open');fresh.setAttribute('aria-hidden','false');}}
        var count=wrap.querySelector('.cd-head h2');
        if(count){var m=count.textContent.match(/\((\d+)\)/);
          if(m)[].forEach.call(document.querySelectorAll('.fb-icon.cart i'),function(i){i.textContent=m[1];});}
      });
  }

  function change(line,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:qty})}).then(refresh);
  }

  document.addEventListener('click',function(e){
    var cartLink=e.target.closest('a.fb-icon.cart, [data-cart-open]');
    if(cartLink){e.preventDefault();open();return;}
    if(e.target.closest('[data-cd-close]')){e.preventDefault();close();return;}
    var q=e.target.closest('[data-cd-qty]');
    if(q){e.preventDefault();change(+q.dataset.cdLine,+q.dataset.cdQty);}
  });
  document.addEventListener('keydown',function(e){
    var d=drawer(); if(e.key==='Escape'&&d&&d.classList.contains('open'))close();
  });

  // adding to cart from our buy box opens the drawer instead of leaving the page
  var addForm=document.getElementById('harderAdd');
  if(addForm){
    addForm.addEventListener('submit',function(e){
      e.preventDefault();
      var fd=new FormData(addForm);
      var btn=addForm.querySelector('#atc'), lbl=btn&&btn.querySelector('.lbl'), old=lbl&&lbl.textContent;
      if(lbl)lbl.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',body:fd})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,body:j};});})
        .then(function(res){
          if(lbl)lbl.textContent=old;
          if(!res.ok){alert(res.body && res.body.description ? res.body.description : 'Could not add to cart.');return;}
          return refresh().then(open);
        })
        .catch(function(){if(lbl)lbl.textContent=old;addForm.submit();});
    });
  }
})();
